import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Cookie } from 'lucide-react';

const KEY = 'vfx_cookie_choice';

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (!v) {
        // small delay so the banner enters after the page settles
        const t = setTimeout(() => setOpen(true), 900);
        return () => clearTimeout(t);
      }
    } catch (_) {}
  }, []);

  const record = (choice) => {
    try {
      localStorage.setItem(
        KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch (_) {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed bottom-4 inset-x-4 lg:inset-x-auto lg:left-6 lg:right-6 lg:bottom-6 z-[60]">
      <div className="max-w-[560px] mx-auto lg:mx-0 lg:ml-auto bg-[#F5F1E8] border border-[#0B3B2E]/20 rounded-2xl shadow-[0_20px_60px_-20px_rgba(11,59,46,0.35)] p-5 lg:p-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-[#0B3B2E] text-[#C8944B] flex items-center justify-center shrink-0">
            <Cookie className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <p className="font-serif text-[18px] text-[#0B3B2E] leading-snug">Your cookies, your call.</p>
            <p className="mt-1 text-[13px] text-[#0E1F1A]/70 leading-relaxed">
              We use essential cookies to run Vector FX and optional cookies to understand how the
              site is used. See our{' '}
              <Link to="/cookies" className="underline text-[#0B3B2E] hover:text-[#12503F]">Cookie Policy</Link> and{' '}
              <Link to="/privacy" className="underline text-[#0B3B2E] hover:text-[#12503F]">Privacy Notice</Link>.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button
                onClick={() => record('all')}
                className="h-9 px-4 rounded-full bg-[#0B3B2E] text-[#F5F1E8] hover:bg-[#12503F] text-[13px] font-medium transition-colors"
              >
                Accept all
              </button>
              <button
                onClick={() => record('essential')}
                className="h-9 px-4 rounded-full border border-[#0B3B2E]/25 text-[#0B3B2E] hover:bg-[#0B3B2E]/5 text-[13px] font-medium transition-colors"
              >
                Essential only
              </button>
              <button
                onClick={() => record('essential')}
                className="h-9 px-4 rounded-full text-[#0E1F1A]/60 hover:text-[#0B3B2E] text-[13px] font-medium transition-colors"
              >
                Reject non-essential
              </button>
            </div>
          </div>
          <button
            aria-label="Dismiss"
            onClick={() => record('essential')}
            className="text-[#0E1F1A]/50 hover:text-[#0B3B2E] transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
